import { ref } from 'vue'
import store from '@/store';
const GetPrivacy = () => {

  const loadedData = ref([])
  const data_error = ref(null)

  const loadData = async () => {
    try {
      let data = await fetch('https://dashboard.imslearn.org/api/privacy')
      if (!data.ok) {
        throw Error('no available courses')
      }
       await data.json().then((res) => {
        if (res.success) {
          loadedData.value = res.data
          store.commit('setPrivacyPolicy',  res.data);
        }else{
          console.log('unable to load data')
          console.log(res) // todo check with zeina what where is the error message in response res.error ?
        }
      })
    }
    catch (err) {
      data_error.value = err.message
    }
  }

  return { loadedData, data_error, loadData }
}

export default GetPrivacy